














































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BarLineChart from '@/components/Charts/BarLineChart.js';
import PieChart from '@/components/Charts/PieChart.js';
import moment from 'moment-timezone';
import { firebaseFunctions } from '@/firebase';
import DateFilter from '@/components/DateFilter.vue';
import constants from '@/utils/constants';

interface ChartType {
  labels?: Array<any>;
  datasets: Array<object>;
}
interface OrderData {
  Android?: number;
  IOS?: number;
  Web?: number;
  COD?: number;
  Cancel?: number;
  Offline?: number;
  Online?: number;
  Prepaid?: number;
  Success?: number;
  Total?: number;
  Unique?: number;
}
interface Data {
  Date: number;
  Order: OrderData;
  Status: Object;
  PaymentMethod: Object;
}

@Component({
  components: {
    DateFilter,
    BarLineChart,
    PieChart
  }
})
export default class Dashboard extends Vue {
  prepaidTransactionOptions: Array<any> = [
    { text: 'Delivery Order (HMD)', value: constants.HMD }
  ];
  selectedTransactionOption: string = constants.HMD;

  transactionStatusOptions: Array<string> = [
    'All Transaction',
    'Online Transaction',
    'Offline Transaction'
  ];
  selectedTransactionStatus: string = 'All Transaction';

  transactionTimelineOptions = {
    selected: 'daily',
    options: [
      { text: 'Daily', value: 'daily' },
      { text: 'Weekly', value: 'weekly' },
      { text: 'Monthly', value: 'monthly' }
    ]
  };

  filterChartOptions = {
    selected: 'all',
    options: [
      { text: 'All Graphs', value: 'all' },
      { text: 'Overview', value: 'overview' },
      { text: 'Transaction Online vs Offline', value: 'onlineVsOffline' },
      {
        text: 'Offline Transaction Payment Methods',
        value: 'offlineTransactionPayment'
      },
      {
        text: 'Online Transaction Payment Methods',
        value: 'onlineTransactionPayment'
      },
      { text: 'Online Transaction Results', value: 'onlineTransactionResults' },
      { text: 'Unique Customer', value: 'uniqueCustomer' },
      { text: 'User Acquisition', value: 'uniqueUser' }
    ]
  };

  // New data
  pieChartOnlineOfflineData: ChartType = {
    labels: ['Online', 'Offline'],
    datasets: []
  };
  pieChartOfflinePaymentMethods: ChartType = {
    labels: ['DANA', 'OTHERS'],
    datasets: []
  };
  pieChartOnlinePaymentMethods: ChartType = {
    labels: ['DANA', 'CASH'],
    datasets: []
  };
  pieChartPrepaidTransactionResults: ChartType = {
    labels: [],
    datasets: []
  };
  uniqueBarChart: ChartType = {
    labels: [],
    datasets: []
  };
  transactionStatusData: ChartType = {
    labels: [],
    datasets: []
  };
  uniqueUsersChart: object = {};
  chartOptions: {
    responsive: boolean;
    maintainAspectRatio: boolean;
  } = {
    responsive: true,
    maintainAspectRatio: false
  };

  public dashboardDetails: any = {
    overview: [],
    payment_method: {},
    Status: {},
    users: []
  };
  public uniqueUsers: Array<any> = [];

  date: any = {
    startDate: moment().startOf('month')
      ? moment()
        .subtract(1, 'day')
        .startOf('month')
        .unix()
      : moment()
        .startOf('month')
        .unix(),
    endDate: moment()
      .subtract(1, 'days')
      .unix()
  };

  readableStartDate: any = moment.unix(this.date.startDate).format('DD-MMMM');
  readableEndDate: any = moment.unix(this.date.endDate).format('DD-MMMM');

  mounted() {
    // this.callFunctions();
  }

  beforeUpdate() {
    this.fillData();
    // this updates all the dates display in each section
    this.readableStartDate = moment.unix(this.date.startDate).format('DD-MMMM');
    this.readableEndDate = moment.unix(this.date.endDate).format('DD-MMMM');
  }

  generateLabels(val1, ...args) {
    let sum = [val1, ...args].reduce((prev, cur) => prev + cur);
    let result: any = (val1 / sum) * 100;
    return isNaN(result) ? 'N/A' : `${parseFloat(result).toFixed(1)}%`;
  }

  callFunctions() {
    this.getDashboardReport();
  }

  // updates the parent data function passed from FilterPanel component
  updateData(filteredData: any) {
    if (filteredData.startDate) {
      this.date.startDate = moment(filteredData.startDate).unix();
    } else if (moment().startOf('month')) {
      this.date.startDate = moment()
        .subtract(1, 'day')
        .startOf('month')
        .unix();
    } else {
      this.date.startDate = moment()
        .startOf('month')
        .unix();
    }
    this.filterChartOptions.selected = filteredData.selectedOne
      ? filteredData.selectedOne
      : 'all';
    // this.date.startDate = filteredData.startDate ? moment(filteredData.startDate).utc().unix() : moment().utc().startOf('month').unix()
    this.date.endDate = filteredData.endDate
      ? moment(filteredData.endDate).unix()
      : moment()
        .subtract(1, 'days')
        .unix();
    // this.callFunctions();
  }
  resetData() {
    this.filterChartOptions.selected = 'all';
    this.date.startDate = moment().startOf('month')
      ? moment()
        .subtract(1, 'day')
        .startOf('month')
        .unix()
      : moment()
        .startOf('month')
        .unix();
    this.date.endDate = moment()
      .subtract(1, 'days')
      .unix();
    // this.callFunctions();
  }

  // @Watch('date.startDate')
  // changeStartDate() {
  //   this.callFunctions();
  // }
  //
  // @Watch('date.endDate')
  // changeEndDate() {
  //   this.callFunctions();
  // }

  // to get dashboard data using OMS function
  getDashboardReport() {
    // const reqPayload = {
    //   startDate: this.date.startDate,
    //   endDate: this.date.endDate
    // };
    // firebaseFunctions
    //   .httpsCallable('getDashboardReport')(reqPayload)
    //   .then(result => {
    //     let overview = result.data.data.overview;
    //     let users = result.data.data.users;
    //     if (overview.type === 'daily') {
    //       let lastDate = Object.keys(overview)[
    //         Object.keys(overview).length - 2
    //       ];
    //       let lastUser = Object.keys(users)[Object.keys(users).length - 2];
    //       delete overview[lastDate];
    //       delete users[lastUser];
    //     }
    //     this.dashboardDetails.overview = overview;
    //     this.dashboardDetails.users = users;
    //     this.dashboardDetails.payment_method = result.data.data.payment_method;
    //     this.dashboardDetails.Status = result.data.data.order_statuses;
    //   })
    //   .then(() => {
    //     this.fillData();
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
  }

  // Fills data in the charts that are defined
  public fillData() {
    let overView = this.dashboardDetails.overview;
    // For Bar Chart (Overview)
    this.transactionStatusData = {
      labels: this.calculateTimeLineNew(overView).dates,
      datasets: [
        {
          label: 'Online',
          backgroundColor: '#68D373',
          data: this.calculateTimeLineNew(overView).online,
          hidden: this.selectedTransactionStatus === 'Offline Transaction'
        },
        {
          label: 'Offline',
          backgroundColor: '#ED706E',
          data: this.calculateTimeLineNew(overView).offline,
          hidden: this.selectedTransactionStatus === 'Online Transaction'
        },
        {
          label: 'Total',
          type: 'line',
          data: this.calculateTimeLineNew(overView).total,
          pointStyle: 'rect',
          pointRadius: 0,
          pointHoverRadius: 5,
          pointBackgroundColor: '#FCDF68',
          borderColor: '#FCDF68',
          backgroundColor: 'rgba(252,223,104, 0.15)',
          hidden: this.selectedTransactionStatus !== 'All Transaction'
        }
      ]
    };

    //   For Piechart (Online Offline both )
    let onlinePayment = this.dashboardDetails.payment_method.online;
    let offlinePayment = this.dashboardDetails.payment_method.offline;
    let totalOnlinePayment = Object.keys(onlinePayment).reduce(
      (sum, key) => sum + parseFloat(onlinePayment[key] || 0),
      0
    );
    let totalOfflinePayment = Object.keys(offlinePayment).reduce(
      (sum, key) => sum + parseFloat(offlinePayment[key] || 0),
      0
    );
    this.pieChartOnlineOfflineData = {
      labels: [
        `Online ${this.generateLabels(
          totalOnlinePayment,
          totalOfflinePayment
        )}`,
        `Offline ${this.generateLabels(
          totalOfflinePayment,
          totalOnlinePayment
        )}`
      ],
      datasets: [
        {
          data: [totalOnlinePayment, totalOfflinePayment],
          backgroundColor: ['#68D373', '#ED706E']
        }
      ]
    };

    //  For Piechart (Only Offline Paymnet Methods )
    this.pieChartOfflinePaymentMethods = {
      labels: [
        `DANA ${this.generateLabels(
          offlinePayment.dana,
          offlinePayment.other
        )}`,
        `OTHERS ${this.generateLabels(
          offlinePayment.other,
          offlinePayment.dana
        )}`
      ],
      datasets: [
        {
          data: [offlinePayment.dana, offlinePayment.other],
          backgroundColor: ['#68D373', '#ED706E']
        }
      ]
    };

    //  For Piechart (Only Online Payment Methods )
    this.pieChartOnlinePaymentMethods = {
      labels: [
        `DANA ${this.generateLabels(onlinePayment.dana, onlinePayment.cash)}`,
        `CASH ${this.generateLabels(onlinePayment.cash, onlinePayment.dana)}`
      ],
      datasets: [
        {
          data: [onlinePayment.dana, onlinePayment.cash],
          backgroundColor: ['#68D373', '#ED706E']
        }
      ]
    };

    //  For PieChart (Prepaid Transaction Result )
    let lable = ['Bad', 'Cancelled', 'Completed', 'Expired', 'FailCreateOrder'];
    let dataArray: any = [];
    let status = this.dashboardDetails.Status[this.selectedTransactionOption];
    lable.forEach(item => {
      let ele = status[item];
      dataArray.push(ele);
    });
    let Bad = this.generateLabels(
      status.Bad,
      status.Cancelled,
      status.Completed,
      status.Expired,
      status.FailCreateOrder
    );
    let Cancelled = this.generateLabels(
      status.Cancelled,
      status.Bad,
      status.Completed,
      status.Expired,
      status.FailCreateOrder
    );
    let Completed = this.generateLabels(
      status.Completed,
      status.Cancelled,
      status.Bad,
      status.Expired,
      status.FailCreateOrder
    );
    let Expired = this.generateLabels(
      status.Expired,
      status.Completed,
      status.Cancelled,
      status.Bad,
      status.FailCreateOrder
    );
    let FailCreateOrder = this.generateLabels(
      status.FailCreateOrder,
      status.Expired,
      status.Completed,
      status.Cancelled,
      status.Bad
    );

    this.pieChartPrepaidTransactionResults = {
      labels: [
        `Bad ${Bad}`,
        `Cancelled ${Cancelled}`,
        `Completed ${Completed}`,
        `Expired ${Expired}`,
        `FailCreateOrder ${FailCreateOrder}`
      ],
      datasets: [
        {
          data: dataArray,
          backgroundColor: [
            '#991B11',
            '#ED706E',
            '#68D373',
            '#FFB249',
            '#FCDF68'
          ]
        }
      ]
    };

    //  For Barchart (Unique Customer )
    this.uniqueBarChart = {
      labels: this.calculateTimeLineNew(overView).dates,
      datasets: [
        {
          label: 'Unique User',
          backgroundColor: '#68D373',
          data: this.calculateTimeLineNew(overView).unique
        },
        {
          label: 'Total Transaction',
          backgroundColor: '#ED706E',
          data: this.calculateTimeLineNew(overView).total
        }
      ]
    };

    //  For Barchart (Unique Acquisition)
    let users = this.dashboardDetails.users;
    this.uniqueUsersChart = {
      labels: this.calculateUserAcquisitionTimiline(users).dates,
      datasets: [
        {
          label: 'Users Registered',
          backgroundColor: '#68D373',
          data: this.calculateUserAcquisitionTimiline(users).data
        }
      ]
    };
  }

  calculateTimeLineNew(obj) {
    this.transactionTimelineOptions.selected = obj.type;
    let dates: any = [];
    let offline: any = [];
    let online: any = [];
    let total: any = [];
    let unique: any = [];
    let that = this;
    Object.keys(obj).forEach(function(key) {
      if (key !== 'type') {
        dates.push(that.getFormatedTimeLine(obj, key));
        offline.push(obj[key].offline);
        online.push(obj[key].online);
        total.push(obj[key].total);
        unique.push(obj[key].unique);
      }
    });
    return {
      dates: dates,
      offline: offline,
      online: online,
      total: total,
      unique: unique
    };
  }

  calculateUserAcquisitionTimiline(obj) {
    this.transactionTimelineOptions.selected = obj.type;
    let dates: any = [];
    let data: any = [];
    let that = this;
    Object.keys(obj).forEach(function(key) {
      if (key !== 'type') {
        dates.push(that.getFormatedTimeLine(obj, key));
        data.push(obj[key]);
      }
    });
    return {
      dates: dates,
      data: data
    };
  }

  getFormatedTimeLine(obj, key) {
    if (obj.type === 'daily') {
      return moment.unix(key).format('DD MMM');
    } else {
      let weeklyArry = key.split('_');
      let firstDay = moment.unix(weeklyArry[0]).format('DD MMM');
      let lastDay = moment.unix(weeklyArry[1]).format('DD MMM');
      return firstDay + ' - ' + lastDay;
    }
  }
}
